export const contentTableConfig = {
  title: '数据库列表',
  propList: [
    {
      prop: 'belongType',
      label: '使用项目',
      minWidth: '40',
      slotName: 'belongType'
    },
    {
      prop: 'environment',
      label: '数据库',
      minWidth: '40'
    },
    {
      prop: 'url',
      label: '数据库地址',
      minWidth: '140',
      align: 'left'
    },
    {
      prop: 'username',
      label: '使用账号',
      minWidth: '40'
    },
    {
      prop: 'aliyunAccount',
      label: '阿里云账号',
      minWidth: '40'
    },
    {
      prop: 'aliyunPassword',
      label: '阿里云密码',
      minWidth: '50',
      slotName: 'password'
    },
    {
      label: '操作',
      minWidth: '80',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
